import { getApiUrl } from "../../services/apiConfig.js";
/* Login/cadastro aditivos. Contas e progresso existentes usam a sessão original. */
(function () {
  "use strict";

  const destinations = {
    aluno: "/conteudos",
    admin: "/admin",
    instituicao: "/instituicao",
    professor: "/professor",
  };
  const years = [
    "6º ano",
    "7º ano",
    "8º ano",
    "9º ano",
    "1º ano do ensino médio",
    "2º ano do ensino médio",
    "3º ano do ensino médio",
    "Ensino médio concluído",
  ];
  const esc = (value) =>
    String(value ?? "").replace(
      /[&<>"']/g,
      (resultado) =>
        ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        })[resultado],
    );
  const icon =
    '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>';
  async function request(action, body, signal) {
    const response = await fetch(
      getApiUrl("/api/access.php?action=" + action),
      {
        method: body ? "POST" : "GET",
        credentials: "same-origin",
        cache: "no-store",
        signal,
        headers: body
          ? {
              "Content-Type": "application/json",
            }
          : {},
        body: body ? JSON.stringify(body) : undefined,
      },
    );
    let json;
    try {
      json = await response.json();
    } catch (error) {
      throw new Error("Não foi possível conectar. Tente novamente.");
    }
    if (!response.ok || json.status !== "success")
      throw new Error(json.message || "Não foi possível concluir.");
    return json.data;
  }
  function sessionFrom(data) {
    if (data?.tipo && data.data && destinations[data.tipo])
      return {
        tipo: data.tipo,
        data: data.data,
      };
    if (data?.tipo === "admin" && data.token)
      return {
        tipo: "admin",
        data,
      };
    if (data?.id && data.learning_token)
      return {
        tipo: "aluno",
        data,
      };
    throw new Error("Não foi possível reconhecer este acesso.");
  }
  function enter(data) {
    const session = sessionFrom(data);
    try {
      sessionStorage.setItem("auth_session", JSON.stringify(session));
    } catch (error) {
      throw new Error("Permita o armazenamento desta página para entrar.");
    }
    window.location.hash = destinations[session.tipo];
    window.location.reload();
  }
  function mountLogin(element) {
    let disposed = false,
      viewVersion = 0,
      currentController = null;
    const dispose = () => {
      disposed = true;
      viewVersion++;
      currentController?.abort();
      element.replaceChildren();
    };
    const shell = (title, subtitle, contents, register = false) => {
      element.innerHTML =
        '<div class="lw dm-access-wrap"><section class="lc dm-access-card' +
        (register ? " dm-register-card" : "") +
        '" aria-label="' +
        esc(title) +
        '">' +
        '<div class="dm-access-icon">' +
        icon +
        "</div><h2>" +
        esc(title) +
        '</h2><div class="sub">' +
        esc(subtitle) +
        "</div>" +
        '<div class="dm-access-error" role="alert" hidden></div>' +
        contents +
        "</section></div>";
    };
    const error = (message) => {
      const box = element.querySelector('[role="alert"]');
      if (box) {
        box.textContent = message;
        box.hidden = false;
      }
    };
    const clearError = () => {
      const box = element.querySelector('[role="alert"]');
      if (box) box.hidden = true;
    };
    function showLogin(message = "") {
      currentController?.abort();
      const version = ++viewVersion;
      shell(
        "Daniel Marlon",
        "Reforço Escolar",
        '<form class="dm-access-form"><div class="fg"><label for="dm-email">E-mail ou apelido</label>' +
          '<input id="dm-email" name="usuario" class="inp" type="text" inputmode="text" autocomplete="username" autocapitalize="none" autocorrect="off" spellcheck="false" required maxlength="254" placeholder="Seu e-mail ou apelido" /></div>' +
          '<div class="fg"><label for="dm-password">Senha</label><input id="dm-password" name="senha" class="inp" type="password" autocomplete="current-password" required placeholder="Sua senha" /></div>' +
          '<button class="btn bb" type="submit">Entrar</button></form>' +
          '<div class="dm-access-bottom"><button type="button" class="dm-access-link" data-register>Cadastrar-se</button></div>',
      );
      // The text input intentionally preserves legacy administrator/student usernames.
      const form = element.querySelector("form");
      const button = form.querySelector('[type="submit"]');
      form.addEventListener("input", clearError);
      element
        .querySelector("[data-register]")
        .addEventListener("click", showRegister);
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        if (!form.reportValidity() || button.disabled) return;
        clearError();
        button.disabled = true;
        button.textContent = "Entrando…";
        currentController = new AbortController();
        try {
          const data = await request(
            "login",
            {
              usuario: form.elements.namedItem("usuario").value.trim(),
              senha: form.elements.namedItem("senha").value,
            },
            currentController.signal,
          );
          if (!disposed && version === viewVersion) enter(data);
        } catch (err) {
          if (!disposed && version === viewVersion && err.name !== "AbortError")
            error(err.message);
        } finally {
          if (!disposed && version === viewVersion) {
            button.disabled = false;
            button.textContent = "Entrar";
          }
        }
      });
      if (message) error(message);
    }
    function showRegister() {
      currentController?.abort();
      const version = ++viewVersion;
      let challenge = null,
        captchaVersion = 0,
        codeVersion = 0,
        codeController = null,
        availableClasses = [];
      shell(
        "Cadastrar-se",
        "Cadastro de aluno",
        '<form class="dm-access-form"><div class="fg"><label for="dm-name">Nome completo</label><input id="dm-name" class="inp" name="name" autocomplete="name" required minlength="2" maxlength="100" /></div>' +
          '<div class="fg"><label for="dm-new-email">E-mail</label><input id="dm-new-email" class="inp" type="email" name="email" autocomplete="email" required maxlength="254" /></div>' +
          '<div class="dm-access-grid"><div class="fg"><label for="dm-new-password">Senha</label><input id="dm-new-password" class="inp" type="password" name="password" autocomplete="new-password" required minlength="6" maxlength="72" placeholder="Mínimo de 6 caracteres" /></div>' +
          '<div class="fg"><label for="dm-confirm">Confirmar senha</label><input id="dm-confirm" class="inp" type="password" name="confirm_password" autocomplete="new-password" required minlength="6" maxlength="72" /></div></div>' +
          '<div class="dm-access-grid"><div class="fg"><label for="dm-code">Código da instituição</label><input id="dm-code" class="inp" name="code" required minlength="2" maxlength="100" autocomplete="off" spellcheck="false" /><div data-institution class="dm-access-caption" aria-live="polite"></div></div>' +
          '<div class="fg"><label for="dm-year">Ano escolar</label><select id="dm-year" class="inp" name="year" required><option value="">Selecione</option>' +
          years.map((year) => "<option>" + esc(year) + "</option>").join("") +
          "</select></div></div>" +
          '<div class="fg" data-class-field hidden><label for="dm-class">Turma (opcional)</label><select id="dm-class" class="inp" name="class_id"><option value="">Selecionar depois</option></select></div>' +
          '<div class="fg dm-captcha"><label for="dm-captcha-answer">Verificação de segurança</label><div class="dm-captcha-row"><img data-captcha alt="Imagem de verificação" width="240" height="72" hidden /><span data-captcha-status role="status">Carregando imagem…</span>' +
          '<button type="button" class="dm-access-link" data-refresh>Outra imagem</button></div><input id="dm-captcha-answer" class="inp" name="captcha_answer" required maxlength="6" autocomplete="off" placeholder="Digite os caracteres da imagem" /></div>' +
          '<button class="btn bb" type="submit" disabled>Cadastrar agora</button></form>' +
          '<div class="dm-access-bottom"><button type="button" class="dm-access-link" data-login>Já tenho conta. Entrar</button></div>',
        true,
      );
      const form = element.querySelector("form");
      const button = form.querySelector('[type="submit"]');
      element
        .querySelector("[data-login]")
        .addEventListener("click", () => showLogin());
      form.addEventListener("input", clearError);
      form.elements
        .namedItem("password")
        .addEventListener("input", () =>
          form.elements.namedItem("confirm_password").setCustomValidity(""),
        );
      form.elements
        .namedItem("confirm_password")
        .addEventListener("input", () =>
          form.elements.namedItem("confirm_password").setCustomValidity(""),
        );
      async function loadCaptcha() {
        const thisCaptcha = ++captchaVersion;
        challenge = null;
        button.disabled = true;
        const status = element.querySelector("[data-captcha-status]");
        const image = element.querySelector("[data-captcha]");
        if (!status || !image) return;
        status.textContent = "Carregando imagem…";
        status.hidden = false;
        image.hidden = true;
        try {
          const data = await request("captcha");
          if (
            disposed ||
            version !== viewVersion ||
            thisCaptcha !== captchaVersion
          )
            return;
          if (
            !/^[a-f0-9]{48}$/.test(data?.id || "") ||
            !/^data:image\/png;base64,[A-Za-z0-9+/=]+$/.test(data?.image || "")
          )
            throw new Error("Verificação de segurança indisponível.");
          challenge = data;
          image.src = data.image;
          image.hidden = false;
          status.hidden = true;
          button.disabled = false;
        } catch (err) {
          if (
            !disposed &&
            version === viewVersion &&
            thisCaptcha === captchaVersion
          ) {
            status.textContent =
              "Não foi possível carregar. Clique em Outra imagem.";
            error(err.message);
          }
        }
      }
      element.querySelector("[data-refresh]").addEventListener("click", () => {
        form.elements.namedItem("captcha_answer").value = "";
        clearError();
        loadCaptcha();
      });
      function showClasses(classes) {
        availableClasses = Array.isArray(classes) ? classes : [];
        const select = form.elements.namedItem("class_id");
        select.innerHTML =
          '<option value="">Selecionar depois</option>' +
          availableClasses
            .map(
              (item) =>
                '<option value="' +
                esc(item.id) +
                '">' +
                esc(
                  item.school_year
                    ? item.school_year + " · " + item.name
                    : item.name,
                ) +
                "</option>",
            )
            .join("");
        element.querySelector("[data-class-field]").hidden =
          availableClasses.length === 0;
      }
      form.elements.namedItem("code").addEventListener("input", () => {
        ++codeVersion;
        codeController?.abort();
        showClasses([]);
        element.querySelector("[data-institution]").textContent = "";
      });
      form.elements.namedItem("code").addEventListener("blur", async () => {
        const code = form.elements
          .namedItem("code")
          .value.trim()
          .replace(/\s+/g, " ")
          .toUpperCase();
        form.elements.namedItem("code").value = code;
        if (code.length < 2) return;
        const sequence = ++codeVersion;
        codeController?.abort();
        codeController = new AbortController();
        try {
          const institution = await request(
            "institution",
            {
              code,
            },
            codeController.signal,
          );
          if (
            !disposed &&
            version === viewVersion &&
            sequence === codeVersion &&
            form.elements.namedItem("code").value === code
          ) {
            element.querySelector("[data-institution]").textContent =
              institution.name || institution.nome || "";
            showClasses(institution.classes);
          }
        } catch (err) {
          if (
            !disposed &&
            version === viewVersion &&
            sequence === codeVersion &&
            err.name !== "AbortError"
          ) {
            element.querySelector("[data-institution]").textContent =
              err.message;
          }
        }
      });
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        form.elements
          .namedItem("confirm_password")
          .setCustomValidity(
            form.elements.namedItem("password").value ===
              form.elements.namedItem("confirm_password").value
              ? ""
              : "As senhas não conferem.",
          );
        if (!form.reportValidity() || button.disabled || !challenge) return;
        if (challenge.expires_at * 1000 <= Date.now()) {
          error("A verificação expirou. Digite a nova imagem.");
          await loadCaptcha();
          return;
        }
        clearError();
        button.disabled = true;
        button.textContent = "Cadastrando…";
        currentController = new AbortController();
        try {
          const data = await request(
            "register",
            {
              name: form.elements.namedItem("name").value.trim(),
              email: form.elements.namedItem("email").value.trim(),
              password: form.elements.namedItem("password").value,
              confirm_password:
                form.elements.namedItem("confirm_password").value,
              code: form.elements
                .namedItem("code")
                .value.trim()
                .replace(/\s+/g, " ")
                .toUpperCase(),
              year: form.elements.namedItem("year").value,
              class_id: form.elements.namedItem("class_id").value || null,
              captcha_id: challenge.id,
              captcha_answer: form.elements
                .namedItem("captcha_answer")
                .value.trim(),
            },
            currentController.signal,
          );
          if (!disposed && version === viewVersion) enter(data);
        } catch (err) {
          if (
            !disposed &&
            version === viewVersion &&
            err.name !== "AbortError"
          ) {
            error(err.message);
            form.elements.namedItem("captcha_answer").value = "";
            await loadCaptcha();
          }
        } finally {
          if (!disposed && version === viewVersion) {
            button.textContent = "Cadastrar agora";
            button.disabled = !challenge;
          }
        }
      });
      loadCaptcha();
    }
    showLogin();
    return dispose;
  }
  function mountPortal(element) {
    let session;
    try {
      session = JSON.parse(sessionStorage.getItem("auth_session") || "null");
    } catch (error) {}
    const role = window.location.hash.split("?")[0].replace("#/", "");
    if (
      !session ||
      !["instituicao", "professor"].includes(session.tipo) ||
      session.tipo !== role ||
      !session.data?.access_token
    ) {
      window.location.replace("#/login-aluno");
      return () => {};
    }
    if (!window.DMInstitutions?.mountPortal) {
      element.innerHTML =
        '<div class="dm-access-panel"><h2>Não foi possível abrir o painel.</h2><p>Atualize a página e tente novamente.</p></div>';
      return () => element.replaceChildren();
    }
    return window.DMInstitutions.mountPortal(element, session);
  }
  window.DMAccess = Object.freeze({
    mountLogin,
    mountPortal,
    sessionFrom,
  });
})();
